import React from 'react'
import throttle from 'lodash/throttle'
import { Carousel, Icon, Pagination } from 'antd'
import { ComponentExt } from 'util/reactExt'
import { Hero } from 'components/layout/CateLayout'
import StarPanel from 'components/StarPanel'
import Menus from '../components/Menus'
import { RouteComponentProps } from '../../../../../../../node_modules/@types/react-router'
import * as styles from './inedx.scss'

import banner from 'assets/images/banner_six.png'
import sixStar from 'assets/images/six_star.png'
import fiveStar from 'assets/images/five_star.png'
import fourStar from 'assets/images/four_star.png'
import threeStar from 'assets/images/three_star.png'
import twoStar from 'assets/images/two_star.png'
import oneStar from 'assets/images/one_star.png'

enum Star {
  seven = 6000107,
  six = 6000106,
  five = 6000105,
  four = 6000104,
  three = 6000103,
  two = 6000102,
  one = 6000101,
}
enum Type {
  // push = 6100101,
  try = 6100102,
  service = 6100103,
}
interface Props extends RouteComponentProps<any> {}
interface State {
  tagindex: number
  swapId: number
  sevenlist: { data: any[]; total: number }
  sixlist: { data: any[]; total: number }
  fivelist: { data: any[]; total: number }
  fourlist: { data: any[]; total: number }
  threelist: { data: any[]; total: number }
  twolist: { data: any[]; total: number }
  onelist: { data: any[]; total: number }
  sixpageindex: number
  fivepageindex: number
  fourpageindex: number
  threepageindex: number
  twopageindex: number
  onepageindex: number
  loading: boolean
  flow: boolean
  anchor: number
}

const PRELIST = ['seven', 'six', 'five', 'four', 'three', 'two', 'one']
const PAGESIZE4 = 4,
  PAGESIZE5 = 3,
  PAGESIZE1 = 5
class HeroPage extends ComponentExt<Props, State> {
  private doms: HTMLElement[] = Array(5).fill(undefined)
  constructor(props) {
    super(props)
    this.state = {
      tagindex: 0,
      swapId: Type.try,
      sevenlist: { data: [], total: 0 },
      sixlist: { data: [], total: 0 },
      fivelist: { data: [], total: 0 },
      fourlist: { data: [], total: 0 },
      threelist: { data: [], total: 0 },
      twolist: { data: [], total: 0 },
      onelist: { data: [], total: 0 },
      sixpageindex: 1,
      fivepageindex: 1,
      fourpageindex: 1,
      threepageindex: 1,
      twopageindex: 1,
      onepageindex: 1,
      loading: true,
      flow: false,
      anchor: 0,
    }
  }

  componentDidMount() {
    const { search } = this.props.location
    const type = new URLSearchParams(search).get('type')
    const { swapId } = this.state
    if (type) {
      this.setState({
        swapId: Number(type),
      })
    }
    this.fetchFirstList(type || swapId)
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  setStateAsync(state) {
    return new Promise(resolve => {
      this.setState(state, resolve)
    })
  }

  async fetchFirstList(team) {
    PRELIST.forEach(async (type, idx, arr) => {
      try {
        const data = await this.api.hero.getList(
          {
            pageindex: 1,
            pagesize:
              type === 'five'
                ? PAGESIZE5
                : type === 'one'
                ? PAGESIZE1
                : type !== 'six'
                ? PAGESIZE4
                : undefined,
          },
          Star[type],
          team,
        )
        await this.setStateAsync({
          [`${type}list`]: data,
        } as any)
        if (idx === arr.length - 1) {
          this.setState({
            loading: false,
          })
        }
      } catch (err) {
        console.error(err.message)
      }
    })
  }

  async fetchList(type: string, pages = { pageindex: 1, pagesize: 3 }, team?) {
    try {
      const data = await this.api.hero.getList(pages, Star[type], team)
      this.setState({
        [`${type}list`]: data,
      } as any)
    } catch (err) {
      console.error(err.message)
    }
  }

  handleScroll = throttle(() => {
    const nodes = this.doms.map(e => e.offsetTop)
    const sct = document.documentElement.scrollTop
    this.setState({
      flow: sct > 860,
      anchor: this.find(sct, nodes),
    })
  }, 200)

  find = (n, arr, i = 0) =>
    arr[i] > n ? i : i !== arr.length ? this.find(n, arr, i + 1) : 5

  handleNav = idx =>
    window.scrollTo({
      top: idx === 0 ? 0 : this.doms[idx - 1].offsetTop,
      behavior: 'smooth',
    })

  tabChange = idx => {
    const { history, location } = this.props
    // const ids = [Type.push, Type.try, Type.service]
    const ids = [Type.try, Type.service]
    PRELIST.forEach(type => {
      this.setState({
        [`${type}pageindex`]: 1,
      } as any)
    })
    history.replace({
      pathname: location.pathname,
      search: `type=${ids[idx]}`,
    })
    this.setState({
      swapId: ids[idx],
    })
    this.fetchFirstList(ids[idx])
  }

  handleClick = (id, type) => window.open(`#/course/${id}?type=${type}`)

  pageChange = (mo, page) => {
    this.setState({
      [`${mo}pageindex`]: page,
    } as any)
    this.fetchList(
      mo,
      {
        pageindex: page,
        pagesize:
          mo === 'five' ? PAGESIZE5 : mo === 'one' ? PAGESIZE1 : PAGESIZE4,
      },
      this.state.swapId,
    )
  }

  render() {
    const { sevenlist } = this.state
    const SixStar = StarPanel.Seven
    const comName = PRELIST.map((item, idx) =>
      idx === 1 || idx === 2
        ? StarPanel.Five
        : idx > 1
        ? StarPanel.Four
        : StarPanel[`${item.charAt(0).toUpperCase() + item.slice(1)}`],
    )
    const layTitle = ['六', '五', '四', '三', '二', '一']
    // const tabs = ['推广', '体验', '服务']
    // const tabids = [Type.push, Type.try, Type.service]
    const tabs = ['体验', '服务']
    const tabids = [Type.try, Type.service]
    const colors = [
      {},
      { r: 255, g: 205, b: 32 },
      { r: 185, g: 156, b: 101 },
      { r: 81, g: 122, b: 239 },
      { r: 69, g: 149, b: 231 },
      { r: 39, g: 204, b: 205 },
    ]
    const stars = [sixStar, fiveStar, fourStar, threeStar, twoStar, oneStar]
    const navibar = () => {
      return (
        <div
          className={styles.navibar}
          style={{
            cursor: 'pointer',
            position: this.state.flow ? 'fixed' : 'absolute',
            top: this.state.flow ? 64 : 780,
          }}
        >
          {['七'].concat(layTitle).map((v, i) => (
            <div
              key={`nav${i}`}
              onClick={() => this.handleNav(i)}
              className={
                i === this.state.anchor
                  ? styles.navibarItemLight
                  : styles.navibarItem
              }
            >
              {v}星
            </div>
          ))}
        </div>
      )
    }
    return (
      <>
        <div className={styles.menu}>
          <Menus defaultKey="quarterhero" />
        </div>
        <div className={styles.hero}>
          <section>
            <div className={styles.heroSixGroup}>
              {tabs.map((v, i) => (
                <span
                  className={
                    tabids.indexOf(this.state.swapId) === i
                      ? styles.heroSixGroupItemLight
                      : styles.heroSixGroupItem
                  }
                  key={i}
                  onClick={() => this.tabChange(i)}
                >
                  {v}
                </span>
              ))}
            </div>
            <div
              className={styles.heroSixBanner}
              style={{
                backgroundImage: `url(${banner})`,
              }}
            >
              <Hero
                title={<span style={{ color: '#FFDAAC' }}>七星上将</span>}
                description=""
                loading={this.state.loading}
                dark
              >
                <div style={{ paddingBottom: 12, width: '100%' }}>
                  <Carousel
                    arrows
                    prevArrow={
                      <div>
                        <Icon type="left" />
                      </div>
                    }
                    nextArrow={
                      <div>
                        <Icon type="right" />
                      </div>
                    }
                    autoplaySpeed={5000}
                  >
                    {!!sevenlist.total ? (
                      sevenlist.data.map(
                        (
                          {
                            article_id,
                            article_type,
                            staff_name,
                            desc,
                            entity_name,
                            img,
                            the_time,
                            tzxy,
                          },
                          idx,
                        ) => (
                          <SixStar
                            key={`six${idx}`}
                            id={article_id}
                            cover={img}
                            name={staff_name}
                            region={entity_name}
                            depart=""
                            time={the_time}
                            intro={desc}
                            desc={tzxy}
                            onClick={() =>
                              this.handleClick(article_id, article_type)
                            }
                          />
                        ),
                      )
                    ) : (
                      <SixStar broken />
                    )}
                  </Carousel>
                </div>
              </Hero>
            </div>
          </section>
          {layTitle.map((item, idx) => {
            const ComName = comName.slice(1)[idx]
            const list = PRELIST.slice(1)
            const datalist = this.state[`${list[idx]}list`].data
            const psmn = [3, 3, 4, 4, 4, 5]
            const fillData = _num =>
              Array(_num)
                .fill(idx)
                .map((v, k) => (
                  <div
                    key={`break${idx}${k}v${v}`}
                    style={{
                      width:
                        idx === 5
                          ? `${100 / 5}%`
                          : idx < 2
                          ? `${100 / 3}%`
                          : `${100 / 4}%`,
                      marginBottom: 20,
                      textAlign: 'center',
                    }}
                  >
                    <ComName
                      one={idx === 5}
                      six={idx === 0}
                      color={colors[idx]}
                      broken
                    />
                  </div>
                ))
            const fillDatas =
              datalist.length % psmn[idx]
                ? fillData(psmn[idx] - (datalist.length % psmn[idx]))
                : datalist.length === 0
                ? fillData(psmn[idx])
                : []
            return (
              <div key={`leyout${idx}`} ref={node => (this.doms[idx] = node)}>
                <Hero
                  title={`${item}星上将`}
                  description=""
                  loading={this.state.loading}
                  star={{ url: stars[idx], count: 6 - idx }}
                >
                  {[]
                    .concat(datalist)
                    .map(
                      (
                        {
                          article_id,
                          article_type,
                          staff_name,
                          desc,
                          entity_name,
                          img,
                          the_time,
                          tzxy,
                        },
                        iidx,
                      ) => {
                        return (
                          <div
                            key={`hero${iidx}`}
                            style={{
                              width:
                                idx === 5
                                  ? `${100 / 5}%`
                                  : idx < 2
                                  ? `${100 / 3}%`
                                  : `${100 / 4}%`,
                              marginBottom: 20,
                              textAlign: 'center',
                            }}
                          >
                            <ComName
                              key={`${item}${idx}`}
                              id={article_id}
                              cover={img}
                              name={staff_name}
                              region={entity_name}
                              depart=""
                              time={the_time}
                              intro={desc}
                              desc={tzxy}
                              temp={item}
                              color={colors[idx]}
                              block={idx < 5}
                              six={idx === 0}
                              one={idx === 5}
                              onClick={() =>
                                this.handleClick(article_id, article_type)
                              }
                            />
                          </div>
                        )
                      },
                    )
                    .concat(fillDatas)}
                  <div style={{ textAlign: 'center', width: '100%' }}>
                    <Pagination
                      total={this.state[`${list[idx]}list`].total}
                      current={this.state[`${list[idx]}pageindex`]}
                      onChange={page => this.pageChange(list[idx], page)}
                      defaultPageSize={
                        list[idx] === 'five'
                          ? PAGESIZE5
                          : list[idx] === 'one'
                          ? PAGESIZE1
                          : list[idx] !== 'seven'
                          ? PAGESIZE4
                          : 4
                      }
                    />
                  </div>
                </Hero>
              </div>
            )
          })}
          {navibar()}
        </div>
      </>
    )
  }
}

export default HeroPage
